/**
 * External dependencies
 */
import {
	ImageUploadPlaceholder, ColumnControl,IconControl, IconDisplay, URLInputControl
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { getBootstrapClasses, range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl, BaseControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.cards.edit.inspector.style.before', 'cartzillagb/cards', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		limit,
		smColumns,
		displaySectionHeader,
        displaySectionTitle,
        displaySectionDesc,
        enableIcon,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
	                label={ __( 'Display Section Header', i18n ) }
	                checked={ displaySectionHeader }
	                onChange={ displaySectionHeader => setAttributes( { displaySectionHeader } ) }
	            />
	            { displaySectionHeader &&
	                <Fragment>
	                    <ToggleControl
	                        label={ __( 'Display Section Title', i18n ) }
	                        checked={ displaySectionTitle }
	                        onChange={ displaySectionTitle => setAttributes( { displaySectionTitle } ) }
	                    />
	                    <ToggleControl
	                        label={ __( 'Display Section Description', i18n ) }
	                        checked={ displaySectionDesc }
	                        onChange={ displaySectionDesc => setAttributes( { displaySectionDesc } ) }
	                    />
	                </Fragment>
	            }

	            <ToggleControl
					label={ __( 'Enable Icon', i18n ) }
					checked={ enableIcon }
					onChange={ enableIcon => setAttributes( { enableIcon } ) }
				/>

				<RangeControl
					label={ __( 'Limit' ) }
					value={ limit }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.cards.edit.inspector.max.limit', 6 ) }
				/>
				
				<ColumnControl
					label={ __("Column Width", i18n ) }
					smColumns={ smColumns }
					smMin={ 1 }
					smMax={ 12 }
					onChangesm={ value => setAttributes( { smColumns: value } ) }
				/>

				

			</PanelBody>	
			{ enableIcon && 
				<PanelBody title={ __( 'Icon Settings', i18n ) }>
					<div className="icon-control-componet-wrapper">
						{ range( 1, limit + 1 ).map( i => {
							const defaulticon ='czi-eye'
							

							const Icon = attributes[ `icon${ i }` ]

							return (
								<IconControl 
									key={ i }
									label={ __( `Icon #${ i }`, i18n ) }
									value={ Icon || defaulticon }
									onChange={ Icon => setAttributes( { [ `icon${ i }` ]: Icon } ) }
								/>
							)
						} ) }
					</div>
				</PanelBody>
			}

			<PanelBody title={ __( 'Card Link Settings', i18n ) } initialOpen={ false }>
				{ range( 1, limit + 1 ).map( i => {

					const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

					return (
						<BaseControl label={ __( `Card Link #${ i } Settings`, i18n ) } id={ "url" }>
							<URLInputControl
								key={ i }
								value={ link }
								onChange={ link => setAttributes( { [ `link${ i }` ]: link } ) }
							/>
						</BaseControl>
						
					)
				} ) }
				
			</PanelBody>
		</Fragment>

		
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		enableContainer,
		limit,
		smColumns,
		displaySectionHeader,
        displaySectionTitle,
        displaySectionDesc,
        title,
        subTitle,
        enableIcon
	} = attributes

	const mainClasses = classnames( [
		className,
		'pt-5 pb-3 pb-lg-5',
		'cards-block'
	], applyFilters( 'cartzillagb.cards.main-block.classes', {
		'container': enableContainer,
	}, props ) )


	const content = range( 1, ( limit ) + 1 ).map( i => {

		const mediaURL = attributes[ `mediaURL${ i }` ]
		const name = attributes[ `name${ i }` ]
		const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'
		

		let defaultname =''

		if ( (i % 6 ) === 1 ) {
			defaultname=(__("Fashion Store v.1", i18n))            
		}

		if ( (i % 6 ) === 2 ) {
			defaultname=(__("Fashion Store v.2", i18n))
		}

		if ( (i % 6 ) === 3 ) {
			defaultname=(__("Electronics Store", i18n))
		}

		if ( (i % 6 ) === 4 ) {
			defaultname=(__("Multi-vendor Marketplace", i18n))            
		}

		if ( (i % 6 ) === 5 ) {
			defaultname=(__("Single Product / Brand Store", i18n))
		}

		if ( (i % 6 ) === 0 ) {
			defaultname=(__("Grocery Store", i18n))
		}

		const defaulticon ='czi-eye'

		const Icon = attributes[ `icon${ i }` ]

		const imageComp = (
			<ImageUploadPlaceholder
				className={ `czgb-cards__image` }
				imageURL={ mediaURL }
				onRemove={ () => {
					setAttributes( {
						[ `mediaURL${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `mediaURL${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ <img src={ mediaURL } alt={ __( 'Multi-vendor Marketplace' ) } /> }
			/>
		)

		const nameComp = (
			<RichText
				tagName='h3'
				className="product-title font-size-lg pt-2"
				value={ name || defaultname }
				onChange={ name => setAttributes( { [ `name${ i }` ]: name } ) }
				placeholder={ __( 'Name' ) }
				keepPlaceholderOnFocus
			/>
		)

		const iconComp = (
			<IconDisplay 
				value={ Icon || defaulticon }
			/>    
		)
		
		const bootstrapClass = getBootstrapClasses( undefined, smColumns, undefined, undefined )

		const output = (
			<div className={ `${ bootstrapClass } mb-4` }  key={ i }>
				<div className="card product-card-alt">
					<div className="product-thumb border">
						{ enableIcon && 
							<div className="product-card-actions">
								<a href={ link } target="_blank" className="btn btn-light btn-icon btn-shadow font-size-base mx-2" rel="noopener noreferrer">
									{ iconComp }
								</a>
							</div>
						}
						<a className="product-thumb-overlay" href={ link } target="_blank" rel="noopener noreferrer"></a>
						{ imageComp }
					</div>
						
					<div className="card-body text-center">
						{ nameComp }                     
					</div>
				</div>
			</div>
		)

		return output
	} )
		

	return (
		<div className={ mainClasses } id="demos">
			<Fragment>
			{ displaySectionHeader &&
				<div className="text-center pt-md-4 pb-2">
				{ displaySectionTitle &&
                    <RichText
						tagName='h2'
						className="title"
						value={ title || '<span class="font-weight-light">Explore</span> Cartzilla Demos' }
						onChange={ title => setAttributes( { title } ) }
						placeholder={ __( 'title' ) }
						keepPlaceholderOnFocus
					/>
                }

                { displaySectionDesc &&
                    <RichText
						tagName='p'
						className="text-muted"
						value={ subTitle || 'Explore the collection of carefully built homepages. More to come soon!' }
						onChange={ subTitle => setAttributes( { subTitle } ) }
						placeholder={ __( 'SubTitle' ) }
						keepPlaceholderOnFocus
					/>
                }
				</div>
			}
				<div className="row pt-4">
					{ content }
				</div>
			</Fragment>
		</div>
	)  
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )